import React, {useEffect, useRef, useState} from 'react';
import icSearch from '../../../images/ic_search.png';
import CustomAlert from '../../../common/components/Alert/CustomAlert';
import Loading from '../../../common/components/Loading/Loading';
import actions from '../../../redux/actions';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import TableHeader from '../../../common/components/ItemTable/TableHeader';
import TableRow from '../../../common/components/ItemTable/TableRow';
import ListPaginator from '../../../common/components/ListPaginator/ListPaginator';
import Chip from '../../../common/components/Chip/Chip';
import _ from 'lodash';

const MedicalServices = (props) => {
    const {
        name,
        title,
        medicalServices,
        switchOfUser,
        getMedicalServicesState,
        medicalServicesListConfig,
        setListConfig,
        getMedicalServices,
        planSelected,
        cleanListConfig,
        showSidebar,
    } = props;
    const listData = [
        {title: 'DESCRIPCION NOMENCLADOR', att: 'medicalServiceName', sort: true},
        {title: 'CODIGO NOMENCLADOR', att: 'medicalServiceCode', center: true, centerTitle: true, sort: true},
        {title: 'RUBRO', att: 'medicalServiceCategory', sort: true},
        {title: 'MODALIDAD', att: 'modality'},
        {title: 'CARENCIA', att: 'daysToPay'},
    ];
    const [search, setSearch] = useState('');
    const [searchTag, setSearchTag] = useState('');

    const [items, setItems] = useState([]);

    const tagNames = {
        medicalServiceName: 'DESCRIPCION NOMENCLADOR',
        medicalServiceCode: 'CÓDIGO NOMENCLADOR',
        medicalServiceCategory: 'RUBRO',
    };
    const [currentPage, setCurrentPage] = useState(-1);

    const pageQuantity = Math.ceil(medicalServices?.totalCount/medicalServicesListConfig.size);

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (getMedicalServicesState.success && medicalServices?.length > 0) {
            switchOfUser('Cobertura de ' + planSelected);
        } else if (getMedicalServicesState.success) {
            switchOfUser('Prestaciones');
        }
        // eslint-disable-next-line
    }, [medicalServices]);

    useEffect(()=> {
        if ( !isInitialMount.current || medicalServicesListConfig === undefined ) {
            setListConfig( {
                list: 'medicalServicesListConfig',
                config: {page: currentPage},
            } );
            getMedicalServices(planSelected);
        }
        isInitialMount.current = false;
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect( ()=>{
        if ( currentPage > pageQuantity ) setCurrentPage( pageQuantity );
        // eslint-disable-next-line
    }, [medicalServices] );

    useEffect(() => {
        cleanListConfig('medicalServicesListConfig');
        setCurrentPage( medicalServicesListConfig?.page ?? -1 );
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setItems(medicalServices);
    }, [medicalServices, getMedicalServicesState.success]);

    const handleSearch = () => {
        const searchTags={...medicalServicesListConfig.searchTags, [searchTag||'medicalServiceName']: search};

        setListConfig( {
            list: 'medicalServicesListConfig',
            config: {search: search, searchTags, page: 1},
        } );
        getMedicalServices(planSelected);

        setSearch('');
    };

    const deleteSearchTag = ( tag ) => {
        const searchTags= _.omit( medicalServicesListConfig?.searchTags, [tag] );

        setListConfig( {
            list: 'medicalServicesListConfig',
            config: {search: search, searchTags},
        } );
        getMedicalServices(planSelected);
    };

    const sortList = (param)=>{
        const element = medicalServicesListConfig?.orderBy?.find((e) => e?.param === param);
        const newElement = {
            param,
            ord: element?.ord === 'asc' ? 'desc' : 'asc',
        };
        const orderBy = [newElement];

        setListConfig( {
            list: 'medicalServicesListConfig',
            config: {orderBy},
        } );

        getMedicalServices(planSelected);
    };

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <p className="ul-p-name">{name}</p>
            <div className="ul-div-section">
                <div className="ul-div-sect-header">
                    <div>
                        <p className="ul-p-title">{title.toUpperCase()}</p>
                        <hr id="id-hr"/>
                    </div>
                    <div>
                        <form onSubmit={(event)=>{
                            handleSearch();
                            event.preventDefault();
                        }} >
                            <div className="ul-div-serchCont">
                                 <div className="ul-div-tagSel">
                                    <select
                                        style={{width: '260px'}}
                                        className="ul-div-searchbar"
                                        onChange={(e) => setSearchTag(e.target.value)}
                                        defaultValue={'medicalServiceName'}
                                    >
                                        <option value={'medicalServiceName'}
                                                selected="selected" >{tagNames['medicalServiceName']}</option>
                                        <option value={'medicalServiceCode'} >{tagNames['medicalServiceCode']}</option>
                                        <option value={'medicalServiceCategory'} >{tagNames['medicalServiceCategory']}</option>
                                    </select>
                                 </div>
                                <div className="ul-div-searchbar">
                                    <input
                                        placeholder="Buscar atención"
                                        value={search}
                                        onChange={(e) => {
                                            setSearch(e.target.value.replace(/[^\w\s]/gi, '').toString());
                                        }}
                                    />
                                    <button type='submit'><img src={icSearch} alt={'search'}/></button>

                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div>
                    { medicalServicesListConfig?.searchTags && Object.keys(medicalServicesListConfig?.searchTags).map( (key)=>
                        <Chip
                            key={key}
                            text={tagNames[key]+': '+medicalServicesListConfig?.searchTags[key]}
                            event={ ()=>{
                                deleteSearchTag(key);
                            } }
                        />,
                    )
                    }
                </div>

                <div className="ul-div-sect-table">
                    { getMedicalServicesState.success?
                        <table className="ul-div-table">
                            <TableHeader listData={listData} sortList={sortList} sortParam={medicalServicesListConfig.orderBy}/>
                            <tbody>
                            {
                                items?.length <= 0 ?
                                    <tr><td colSpan={100} ><CustomAlert text='prestaciones' /></td></tr> :
                                    items?.map((item, index) =>
                                        <TableRow key={index} listData={listData} data={item} />,
                                    )
                            }
                            </tbody>
                        </table> :
                        getMedicalServicesState.loading?<Loading className="ul-div-sect-table" />:
                            <CustomAlert text={'prestaciones' || String(getMedicalServicesState.error)} severity='error' />
                    }
                    <div className="ul-div-bottom">
                        <ListPaginator
                            pageQuantity={pageQuantity}
                            currentPage={medicalServicesListConfig.page}
                            setCurrentPage={setCurrentPage}
                            initInOne={true}
                        />
                    </div>
                </div>

            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    title: state.home.title,
    medicalServices: state.home.medicalServices,
    getMedicalServicesState: state.home.getMedicalServicesState,
    medicalServicesListConfig: state.home.medicalServicesListConfig,
    planSelected: state.home.planSelected,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    setListConfig: (body) => dispatch( actions.home.setListConfig(body) ),
    getMedicalServices: (plans) => dispatch( actions.home.getMedicalServicesRequest(plans) ),
    cleanListConfig: (list) => dispatch( actions.home.cleanListConfig(list) ),
});

MedicalServices.propTypes = {
    name: PropTypes.string,
    columnDataPlans: PropTypes.object,
    title: PropTypes.string,
    medicalServices: PropTypes.object,
    getMedicalServicesState: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(MedicalServices);

